import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { LexiconModule } from '@galaxy/lexicon';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { VaCardsModule } from '@vendasta/uikit';
import baseTranslation from '../../../assets/i18n/en_devel.json';
import { AssignedSalespersonModule } from '../../assigned-salesperson/assigned-salesperson.module';
import { PricePipe } from '../../common/pipes/price.pipe';
import { WEBLATE_COMPONENT_NAME } from '../../constants';
import { CurrentPlanComponent } from './current-plan/current-plan.component';

@NgModule({
  declarations: [CurrentPlanComponent],
  imports: [
    CommonModule,
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    MatCardModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    VaCardsModule,
    MatIconModule,
    AssignedSalespersonModule,
    GalaxyPipesModule,
    GalaxyAlertModule,
    PricePipe,
  ],
  exports: [CurrentPlanComponent],
})
export class SubscriptionTierUtilsModule {}
